// Browser-local diagnostics only. Never log URLs, query strings, cookies,
// grants, raw HLS errors, user identities or request/response headers.
export function cameraDiagnostics(camera, emit = line => console.warn(line), now = Date.now) {
  let count = 0;
  const last = new Map();
  return (event, fields = {}) => {
    const time = now();
    const key = `${event}:${fields.detail || ""}:${fields.status || 0}`;
    if (count >= 100 || (last.has(key) && time - last.get(key) < 10000)) return;
    last.set(key, time); count++;
    const row = { event, camera: camera.id, kind: camera.kind, at: new Date(time).toISOString() };
    for (const name of ["status", "readyState", "networkState", "mediaCode", "stallMs", "bufferSeconds"]) {
      if (Number.isFinite(fields[name])) row[name] = Math.round(fields[name] * 100) / 100;
    }
    for (const name of ["type", "detail"]) {
      if (typeof fields[name] === "string" && /^[a-zA-Z0-9_]{1,64}$/.test(fields[name])) row[name] = fields[name];
    }
    if (typeof fields.fatal === "boolean") row.fatal = fields.fatal;
    emit(`[camera] ${JSON.stringify(row)}`);
  };
}

export function mediaState(media) {
  let bufferSeconds = 0;
  for (let i = 0; i < media.buffered.length; i++) {
    if (media.buffered.start(i) <= media.currentTime && media.buffered.end(i) >= media.currentTime) {
      bufferSeconds = media.buffered.end(i) - media.currentTime;
    }
  }
  return { readyState: media.readyState, networkState: media.networkState, mediaCode: media.error?.code || 0, bufferSeconds };
}

// An img error contains no HTTP status. A single bounded HEAD probe distinguishes
// HTTP failures from a JPEG decode failure without downloading another image.
export async function probePreview(url, signal, report) {
  try {
    const target = new URL(url);
    if (target.origin !== "https://stream.inglis.com.au" || !/^\/(boxes\/k\/\d+|areas\/[a-z-]+)\/latest\.jpg$/.test(target.pathname)) return;
    const reply = await fetch(target.href, { method: "HEAD", credentials: "include", signal });
    if (!signal.aborted) report("preview_probe", { status: reply.status });
  } catch (_) {
    if (!signal.aborted) report("preview_probe", { detail: "networkOrCors" });
  }
}
